import { useQuery } from "@tanstack/react-query";
import { HOME } from "../constants/testIds";
import Reveal from "../components/loadout/Reveal";
import ProductCard from "../components/loadout/ProductCard";
import Button from "../components/loadout/Button";
import { productsForBestsellers } from "../lib/shopify/queries";

// [8] Bestsellers — 96px padding, white bg. Server-side criterion is the
// exact case-sensitive Shopify tag `bestseller` (no fallbacks). staleTime is
// kept under 60s so Shopify Admin tag edits surface within a minute.
export default function BestsellersGrid() {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["shopify", "bestsellers", { first: 8 }],
    queryFn: () => productsForBestsellers({ first: 8 }),
    staleTime: 30 * 1000,
  });

  const products = (data?.products || []).slice(0, 8);

  return (
    <section
      data-testid={HOME.bestsellersSection}
      className="bg-white pt-16 pb-8 md:pt-24 md:pb-10"
    >
      <div className="mx-auto max-w-[1440px] px-6">
        <div className="flex items-end justify-between gap-6 flex-wrap">
          <div>
            <Reveal>
              <div className="font-mono text-[11px] uppercase tracking-[0.16em] text-[#8A8A8A]">
                01 / BESTSELLERS
              </div>
            </Reveal>
            <Reveal delay={60}>
              <h2 className="mt-4 font-display text-[#0A0A0A] text-[32px] md:text-[48px] leading-[0.95] max-w-[720px]">
                What operators are deploying this week.
              </h2>
            </Reveal>
          </div>
          <a
            href="/collections/best-sellers"
            data-testid={HOME.bestsellersViewAll}
            className="font-sans text-[13px] font-semibold uppercase tracking-[0.04em] text-[#0A0A0A] hover:text-[#FF9F1C] transition-colors border-b border-[#0A0A0A] hover:border-[#FF9F1C] pb-0.5"
          >
            View All →
          </a>
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {isLoading &&
            Array.from({ length: 8 }).map((_, i) => (
              <div key={i} className="border border-[#EAEAEA] bg-white">
                <div className="aspect-[4/5] bg-[#FAFAFA] animate-pulse" />
                <div className="p-4 space-y-2">
                  <div className="h-3 w-1/3 bg-[#FAFAFA] animate-pulse" />
                  <div className="h-4 w-4/5 bg-[#FAFAFA] animate-pulse" />
                  <div className="h-4 w-1/4 bg-[#FAFAFA] animate-pulse" />
                </div>
              </div>
            ))}

          {!isLoading && !isError &&
            products.map((p, i) => (
              <Reveal key={p.id} delay={40 * i}>
                <ProductCard product={p} />
              </Reveal>
            ))}

          {isError && (
            <div className="col-span-full py-16 text-center font-mono text-[12px] uppercase tracking-[0.06em] text-[#8A8A8A]">
              COULD NOT LOAD BESTSELLERS
            </div>
          )}

          {!isLoading && !isError && products.length === 0 && (
            <div className="col-span-full py-16 text-center font-mono text-[12px] uppercase tracking-[0.06em] text-[#8A8A8A]">
              CATALOG EMPTY
            </div>
          )}
        </div>

        <div className="mt-12 flex justify-center">
          <Button
            as="a"
            href="/collections/best-sellers"
            variant="secondaryLight"
          >
            View All Bestsellers →
          </Button>
        </div>
      </div>
    </section>
  );
}
